// extracted by mini-css-extract-plugin
export var articleSummary = "post-module--articleSummary--a8646";
export var counterNote = "post-module--counterNote--5067c";
export var counterSection = "post-module--counterSection--1eed4";
export var likeButton = "post-module--likeButton--4a1d9";
export var likeCount = "post-module--likeCount--cc00c";
export var postTitle = "post-module--postTitle--a1aa2";
export var shareArea = "post-module--shareArea--b23b2";